import { combineReducers } from 'redux'

import { UsuarioReducer } from './usuario/reducer/usuarioReducers';
import { FilialReducer } from './filial/reducer/filialReducers';
import { AuthenticationReducer } from './authentication/reducer/authenticationReducers';

import { UtilReducer } from './util/reducer/utilReducers';
import { StoreAplication } from '../main';
import { SistemaReducer } from './sistema/reducer/sistemaReducers';
import { PerfilReducer } from './perfil/reducer/perfilReducers';
import { IBGEReducer } from './ibge/reducer/ibgeReducers';
import { BaseReducer } from './base/reducers/baseReducers'
import { UsuarioSistemaPerfilReducer } from './usuarioSistemaPerfil/reducer/usuarioSistemaPerfilReducers';

export const RootBaseReducerList = {
    AuthenticationReducer,
    BaseReducer,
    UsuarioReducer,
    FilialReducer,
    SistemaReducer,
    UtilReducer,
    PerfilReducer,
    IBGEReducer,
    UsuarioSistemaPerfilReducer
}

const RootBaseReducer = combineReducers(RootBaseReducerList);

export default RootBaseReducer;

export type RootStateBase = ReturnType<typeof RootBaseReducer>


export function GetState(): RootStateBase {
    return StoreAplication.getState()
}
